import { WCCFooter } from '../WCCFooter/WCCFooter';
import { WCCHeader } from '../WCCHeader/WCCHeader';
import { StepProps, Stepper } from '@molecules/Stepper/Stepper';
import { CookieBanner } from '@molecules/CookieBanner/CookieBanner';
import { FunctionComponent, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Please note that the footer uses grid areas to layout the content.
 * To use this component, user should ensure that the gridTemplateColumns and gridTemplateAreas are defined in the tailwind.config.js file
 * Additionally, to use it with tailwind, @savvywombat/tailwindcss-grid-areas plugin should be added in the talwind.config.js
 */

export type LayoutProps = {
  children?: ReactNode;
  steps: StepProps[];
};

export const Layout: FunctionComponent<LayoutProps> = ({ children, steps }) => {
  const { pathname } = useLocation();
  const urlPaths = steps.flatMap((step) => step.urlPaths);
  const enableStepper = urlPaths.includes(pathname);
  return (
    <main className="grid min-h-screen grid-rows-[min-content_min-content_auto] overflow-hidden overflow-x-hidden bg-white">
      <CookieBanner />
      <WCCHeader />
      <section
        id="main-content-heading"
        className="px-6 md:px-10 lg:px-16 xl:px-[12.5%]"
      >
        {enableStepper && <Stepper pathname={pathname} steps={steps} />}
      </section>
      <section
        id="main-content"
        className="h-full px-6 pb-20 md:px-10 lg:px-16 xl:px-[12.5%]"
      >
        {children}
      </section>
      <WCCFooter />
    </main>
  );
};

export default Layout;
